import React, { FC } from 'react';
import { AuditLog } from '@/types';
import { currencyFormatted } from '@/utils/helpers';
import { Spin, Alert } from 'antd';
import { useDamageLineById } from '@/api/Inspections/hooks/useInspectionsVehicles';
import { useTranslate } from '@/translations';

interface DamageLineDetailsProps {
  data: AuditLog;
  inspectionId: number;
}

export const DamageLineDetails: FC<DamageLineDetailsProps> = ({
  data,
  inspectionId,
}) => {
  const { t } = useTranslate();
  const currentDamageLineKey = data.eventKey;

  const {
    data: damageLineData,
    isFetching,
    isError,
  } = useDamageLineById(inspectionId, currentDamageLineKey);

  return (
    <div>
      <h6>{t('damageLineDetails')}</h6>
      {data && (
        <p>
          {t('eventKey')}: {data.eventKey}
        </p>
      )}

      {isFetching && (
        <div className="text-center p-3">
          <Spin tip={t('loadingDamageLineDetails')} />
        </div>
      )}

      {isError && (
        <Alert
          message="Error"
          description={t('failedToLoadDamageLineDetails')}
          type="error"
          showIcon
        />
      )}

      {!isFetching && !isError && damageLineData ? (
        <div className="damage-line-details">
          <p>
            <strong>{t('location')}:</strong>{' '}
            {damageLineData.damageAreaDesc || ''}
          </p>
          <p>
            <strong>{t('partComp')}:</strong>{' '}
            {damageLineData.damagePartDesc || damageLineData.partCode || ''}
          </p>
          <p>
            <strong>{t('damageType')}:</strong>{' '}
            {damageLineData.damageTypeDesc || damageLineData.damageType || ''}
          </p>
          <p>
            <strong>{t('sector')}:</strong> {damageLineData.sector || ''}
          </p>
          <p>
            <strong>{t('severity')}:</strong>{' '}
            {damageLineData.severityDesc ||
              (damageLineData.severityId
                ? String(damageLineData.severityId)
                : '')}
          </p>
          {damageLineData.lineCost !== undefined && (
            <p>
              <strong>{t('cost')}:</strong>{' '}
              {currencyFormatted(damageLineData.lineCost)}
            </p>
          )}
          {damageLineData.note && (
            <p>
              <strong>{t('note')}:</strong> {damageLineData.note}
            </p>
          )}
        </div>
      ) : (
        !isFetching &&
        !damageLineData && (
          <Alert
            message={t('noData')}
            description={t('noDamageLineDetailsFound')}
            type="info"
            showIcon
          />
        )
      )}
    </div>
  );
};
